export const styles = {
	container: {
		textAlign: 'center',
	},
	errorIcon: {
		'@media (max-width:380px)': {
			transform: 'scale(0.75)',
		},
	},
};
